"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 print-p flex flex-col" };
const _hoisted_2 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_5 = {
    key: 0,
    class: "w-full bg-gray-dark text-white text-center font-bold p-4"
};
const _hoisted_6 = { class: "flex items-center justify-center gap-2" };
const _hoisted_7 = { class: "text-center font-bold" };
const _hoisted_8 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_9 = { class: "text-center" };
const _hoisted_10 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_11 = { class: "text-center" };
const _hoisted_12 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_13 = { class: "text-left font-bold text-[14px]" };
const _hoisted_14 = { class: "text-left text-[14px]" };
const _hoisted_15 = { class: "flex items-center justify-center gap-2 text-left" };
const _hoisted_16 = { class: "text-left font-bold text-[14px]" };
const _hoisted_17 = { class: "text-left text-[14px]" };
const _hoisted_18 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_19 = { class: "text-right text-[14px]" };
const _hoisted_20 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_21 = { class: "text-right text-[14px]" };
const _hoisted_22 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_23 = { class: "text-right text-[14px]" };
const _hoisted_24 = { class: "flex flex-row gap-1 justify-center items-center print:hidden" };
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-envelope" }, null, -1);
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { class: "font-bold text-center" };
const _hoisted_30 = { class: "flex justify-center items-center mb-4" };
const _hoisted_31 = { class: "flex justify-center items-center" };
const _hoisted_32 = ["disabled"];
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const InvoiceItems_vue_1 = __importDefault(require("./InvoiceItems.vue"));
const shop_1 = require("../../common/utils/shop");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const invoiceStore_1 = require("../../stores/invoice/invoiceStore");
const vue_router_1 = require("vue-router");
const i18n_1 = require("../../common/i18n");
const validators_1 = require("../../common/utils/validators");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Invoices',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const invoiceStore = (0, invoiceStore_1.useInvoiceStore)();
        const showNoHits = (0, vue_3.ref)(false);
        const invoices = (0, vue_3.computed)(() => invoiceStore.getInvoices || []);
        const selectedInvoice = (0, vue_3.ref)(null);
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const invoiceItemsModalIsOpen = (0, vue_3.ref)(false);
        const sendInvoiceCopyInEmailModalIsOpen = (0, vue_3.ref)(false);
        const isArchivedInvoice = (0, vue_3.ref)(false);
        const invoiceCopyEmail = (0, vue_3.ref)("");
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            invoiceIdPartial: "",
            itemId: "",
        });
        const invoiceListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("invoice_id_invoice_list", "Invoice ID", "invoices")) !== null && _a !== void 0 ? _a : "Invoice ID",
                value: "id",
            },
            {
                key: "createdDate",
                label: (_b = (0, i18n_1.trans)("created_date_invoice_list", "Created Date", "invoices")) !== null && _b !== void 0 ? _b : "Created Date",
                value: "createdDate",
            },
            {
                key: "deadlineDate",
                label: (_c = (0, i18n_1.trans)("deadline_date_invoice_list", "Deadline Date", "invoices")) !== null && _c !== void 0 ? _c : "Deadline Date",
                value: "deadlineDate",
            },
            {
                key: "paymentCondition",
                label: (_d = (0, i18n_1.trans)("payment_condition_invoice_list", "Payment Condition", "invoices")) !== null && _d !== void 0 ? _d : "Payment Condition",
                value: "paymentCondition",
            },
            {
                key: "invoiceName",
                label: (_e = (0, i18n_1.trans)("delivery_and_invoice_address_invoice_list", "Delivery & Invoice Address", "invoices")) !== null && _e !== void 0 ? _e : "Delivery & Invoice Address",
                value: "invoiceName",
            },
            {
                key: "netAmount",
                label: (_f = (0, i18n_1.trans)("net_amount_invoice_list", "Net Amount", "invoices")) !== null && _f !== void 0 ? _f : "Net Amount",
                value: "netAmount",
            },
            {
                key: "vatAmount",
                label: (_g = (0, i18n_1.trans)("vat_amount_invoice_list", "Vat Amount", "invoices")) !== null && _g !== void 0 ? _g : "Vat Amount",
                value: "vatAmount",
            },
            {
                key: "grossAmount",
                label: (_h = (0, i18n_1.trans)("gross_amount_invoice_list", "Gross Amount", "invoices")) !== null && _h !== void 0 ? _h : "Gross Amount",
                value: "grossAmount",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const printPage = () => {
            window.print();
        };
        const queryInvoices = async () => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "invoices")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            try {
                await invoiceStore.fetchInvoices(router, filter.value, securityStore.authenticatedUser.customer.id);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            finally {
                showNoHits.value = !invoices.value || invoices.value.length === 0;
            }
        };
        const viewInvoiceItems = async (invoice) => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "invoices")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            selectedInvoice.value = invoice;
            invoiceStore.resetInvoiceItems();
            try {
                await invoiceStore.fetchInvoiceItems(router, { customerId: securityStore.authenticatedUser.customer.id, invoiceId: invoice.id });
                invoiceItemsModalIsOpen.value = true;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const openSendingInvoiceCopyInEmailModal = (invoice) => {
            selectedInvoice.value = invoice;
            sendInvoiceCopyInEmailModalIsOpen.value = true;
        };
        const sendInvoiceCopyInEmail = async () => {
            var _a, _b, _c, _d;
            if (selectedInvoice.value !== null) {
                if ((0, shop_1.formatDate)(new Date(selectedInvoice.value.createdDate)) < (0, shop_1.formatDate)(new Date('2024.01.01')) &&
                    selectedInvoice.value.invoiceFilename == '') {
                    isArchivedInvoice.value = true;
                }
            }
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "invoices")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            if (confirm((_b = (0, i18n_1.trans)("send_invoice_copy_in_email_confirm", `Are you really want to send invoice copy to {email}`, "invoices", { email: invoiceCopyEmail.value })) !== null && _b !== void 0 ? _b : `Are you really want to send invoice copy to ${invoiceCopyEmail.value}`)) {
                try {
                    await invoiceStore.sendInvoiceCopyInEmail(router, {
                        email: invoiceCopyEmail.value,
                        invoiceId: (_d = (_c = selectedInvoice.value) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : "",
                        isArchived: isArchivedInvoice.value,
                        customerId: securityStore.authenticatedUser.customer.id,
                    });
                    sendInvoiceCopyInEmailModalIsOpen.value = false;
                    if (isArchivedInvoice.value) {
                        toastStore.addToast({
                            message: (0, i18n_1.trans)("our_colleague_will_contact_you_shortly", "Our colleague will contact you shortly", "invoices"),
                            type: "info",
                            timer: 15
                        });
                    }
                    else {
                        toastStore.addToast({
                            message: (0, i18n_1.trans)("email_sent_successfully", "Email is sent successfully!", "invoices"),
                            type: "success",
                            timer: 5
                        });
                    }
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const formatInvoiceAddress = (invoice) => {
            return `${invoice.invoiceName} ${invoice.invoiceZipCode} ${invoice.invoiceCity} ${invoice.invoiceStreet}`;
        };
        const formatDeliveryAddress = (invoice) => {
            return `${invoice.deliveryName} ${invoice.deliveryZipCode} ${invoice.deliveryCity} ${invoice.deliveryStreet}`;
        };
        const isEmailAddressValid = () => {
            return !(0, validators_1.isBlank)(invoiceCopyEmail.value) && (0, validators_1.isValidEmail)(invoiceCopyEmail.value);
        };
        (0, vue_3.onBeforeMount)(() => {
            invoiceStore.reset();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'invoices'),
                            label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'invoices'),
                            modelValue: filter.value.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter.value.startDate) = $event)),
                            class: "invoice-filter-input",
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'invoices'),
                            label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'invoices'),
                            modelValue: filter.value.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filter.value.endDate) = $event)),
                            class: "invoice-filter-input",
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('invoice_id_placeholder', 'e.g.: SZ111000040', 'invoices'),
                            label: (0, vue_2.unref)(i18n_1.trans)('invoide_id_partial', 'Invoice ID Partial', 'invoices'),
                            modelValue: filter.value.invoiceIdPartial,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filter.value.invoiceIdPartial) = $event)),
                            class: "invoice-filter-input",
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[3] || (_cache[3] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[48px]",
                            onClick: queryInvoices
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "invoices")), 1)
                    ])
                ]),
                (showNoHits.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("no_invoices_to_display", "No invoices to display", "invoices")), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(invoices).length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                        key: 1,
                        fields: invoiceListFields.value,
                        "onUpdate:fields": _cache[4] || (_cache[4] = ($event) => ((invoiceListFields).value = $event)),
                        items: (0, vue_2.unref)(invoices),
                        striped: "",
                        condensed: "",
                        panel: "",
                        class: "print-mt-4"
                    }, {
                        "head-id": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoide_id", "Invoice ID", "invoices")), 1)
                        ]),
                        "cell-id": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(invoice.id), 1)
                        ]),
                        "head-createdDate": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("created_date", "Created Date", "invoices")), 1)
                        ]),
                        "cell-createdDate": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)(invoice.createdDate), 1)
                        ]),
                        "head-deadlineDate": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("deadline_date", "Deadline Date", "invoices")), 1)
                        ]),
                        "cell-deadlineDate": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)(invoice.deadlineDate), 1)
                        ]),
                        "head-paymentCondition": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("payment_condition", "PaymentCondition", "invoices")), 1)
                        ]),
                        "cell-paymentCondition": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)(invoice.payment), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(invoice.paymentCondition), 1)
                        ]),
                        "head-invoiceName": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_delivery_address", "Invoice & Delivery Address", "invoices")), 1)
                        ]),
                        "cell-invoiceName": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)(formatInvoiceAddress(invoice)), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)(formatDeliveryAddress(invoice)), 1)
                        ]),
                        "head-netAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("net_amount", "Net Amount", "invoices")), 1)
                        ]),
                        "cell-netAmount": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)(invoice.formattedNetAmount), 1)
                        ]),
                        "head-vatAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("vat_amount", "Vat Amount", "invoices")), 1)
                        ]),
                        "cell-vatAmount": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)(invoice.formattedVatAmount), 1)
                        ]),
                        "head-grossAmount": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("gross_amount", "Gross Amount", "invoices")), 1)
                        ]),
                        "cell-grossAmount": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)(invoice.formattedGrossAmount), 1)
                        ]),
                        "cell-actions": (0, vue_2.withCtx)(({ item: invoice }) => [
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-primary btn-link",
                                    onClick: ($event) => (viewInvoiceItems(invoice))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("view_invoice_items", "View Invoice Items", "invoices")), 9, _hoisted_25),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-danger btn-link print:hidden",
                                    onClick: ($event) => (openSendingInvoiceCopyInEmailModal(invoice))
                                }, _hoisted_28, 8, _hoisted_26)
                            ])
                        ]),
                        _: 1
                    }, 8, ["fields", "items"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: invoiceItemsModalIsOpen.value,
                    title: selectedInvoice.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('view_invoice', 'View Invoice - Invoice ID: {id}', 'invoices', { id: selectedInvoice.value.id })
                        : '',
                    onClose: _cache[5] || (_cache[5] = ($event) => (invoiceItemsModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(InvoiceItems_vue_1.default)
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: sendInvoiceCopyInEmailModalIsOpen.value,
                    title: selectedInvoice.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('send_invoice_copy_in_email', 'Send Invoice Copy In Email - Invoice ID: {id}', 'invoices', { id: selectedInvoice.value.id })
                        : '',
                    onClose: _cache[7] || (_cache[7] = ($event) => (sendInvoiceCopyInEmailModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("selected_invoice_copy_can_be_sent_in_pdf", "The selected invoice copy can be sent in PDF format to the given email address.", "invoices")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_30, [
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                label: (0, vue_2.unref)(i18n_1.trans)('email_address', 'Email address', 'invoices'),
                                modelValue: invoiceCopyEmail.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((invoiceCopyEmail).value = $event)),
                                class: "w-[300px]",
                                type: "email",
                                required: "",
                                border: "",
                                "show-validity": true,
                                valid: isEmailAddressValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('email_address_required', 'Email address required', 'invoices')
                            }, null, 8, ["label", "modelValue", "valid", "invalid-message"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_31, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary inline",
                                onClick: sendInvoiceCopyInEmail,
                                disabled: !isEmailAddressValid()
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("send_email", "Send Email", "invoices")), 9, _hoisted_32)
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
